import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
  root: {
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
    scrollX: 'none',
    overflowY: 'hidden',
    scrollY: 'none',


  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

let id = 0;
function createData(name, calories, fat, carbs, protein) {
  id += 1;
  return { id, name, calories, fat, carbs, protein };
}

function CustomizedTable(props) {
  const { classes, dataset } = props;

  return (
    <Paper className={classes.root}>
      <AppBar position="static">
        <Typography variant="title" color="inherit">Dataset Information</Typography>
      </AppBar>
      {dataset && dataset.fields && (
          <div style={{ textAlign: 'left', paddingLeft: '15px', paddingTop: '15px' }}>
              <Typography variant="headline">Total Classes: {dataset.class_count}</Typography>
              <Typography variant="headline">Total Labelings: {dataset.label_count}</Typography>
              <Typography variant="headline">Total Images: {dataset.item_count}</Typography>
              <Typography variant="headline">Creation Date: {dataset.fields.created_at}</Typography>
          </div>
      )}
    </Paper>
  );
}

CustomizedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(CustomizedTable);



// WEBPACK FOOTER //
// ./src/components/dataset_info.jsx